/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
export enum RunningStatusTypeE {
    UNKNOWN = 0,
    NORMAL = 1,
    RUNNING = 2,
    NOT_RUNNING = 3,
    NOT_EXIST = 4,
    HIGH_TEMPERATURE_SLEEP = 5,
    STARTING = 6,
    POWER_FAILURE_PROTECTING = 7,
    SLEEPING = 8,
    SPINGUP = 9,
    LINK_UP = 10,
    LINK_DOWN = 11,
    POWER_ON = 12,
    POWER_OFF = 13,
    PRE_COPY = 14,
    COPYBACK = 15,
    RECONSTRUCTION = 16,
    EXPANSION = 17,
    NOT_FORMAT = 18,
    FORMATTING = 19,
    UNMAPPING = 20,
    INITIAL_SYNCHRONIZING = 21,
    CONSISTENT = 22,
    SYNCHRONIZING = 23,
    SYNCHRONIZED = 24,
    NOT_SYNCHRONIZED = 25,
    SPLIT = 26,
    ONLINE = 27,
    OFFLINE = 28,
    LOCKED = 29,
    ENABLE = 30,
    DISABLED = 31,
    LEVELING = 32,
    TO_BE_RECOVERD = 33,
    INTERRUPTED = 34,
    INVALID = 35,
    NOSTART = 36,
    QUEUING = 37,
    STOP = 38,
    COPYING = 39,
    COMPLETED = 40,
    PAUSE = 41,
    REVSYNCHRONIZING = 42,
    ACTIVATED = 43,
    ROLLBACK = 44,
    INACTIVATED = 45,
    IDLE = 46,
    POWERING_OFF = 47,
    CHARGING = 48,
    CHARGED = 49,
    DISCHARGING = 50,
    UPGRADING = 51,
    POWER_LOST = 52,
    INITIALIZING = 53,
    APPLY_CONFIG_CHANGE = 54,
    ONLINE_DISABLE = 55,
    OFFLINE_DISABLE = 56,
    ONLINE_FROZEN = 57,
    OFFLINE_FROZEN = 58,
    CLOSED = 59,
    REMOVING = 60,
    INSERVICE = 61,
    OUTOFSERVICE = 62,
    ERASEMENT_RUNNING_NORMAL = 63,
    ERASEMENT_RUNNING_FAIL = 64,
    ERASEMENT_RUNNING_SUCCESS = 65,
    CANCELING = 69,
    CANCELED = 70,
    MIGRATION_FAULT = 74,
    MIGRATING = 75,
    MIGRATION_COMPLETED = 76,
    ACTIVATING = 77,
    DEACTIVATING = 78,
    SHEDULING = 85,
    PAUSING = 86,
    SUSPENDING = 87,
    SUSPENDED = 88,
    OVERLOAD = 89,
    TO_BE_SWITCH = 90,
    SWITCHING = 91,
    TO_BE_CLEANUP = 92,
    FORCED_START = 93,
    ERROR = 94,
    JOB_COMPLETED = 95,
    PARTITION_MIGRATING = 96,
    MOUNT = 97,
    UNMOUNT = 98,
    INSTALLING = 99,
    TO_BE_SYNCHRONIZED = 100,
    CONNECTING = 101,
    POWER_ON_ERROR = 103,
    REPAIRING = 104,
    ABNORMAL = 105,
    DELETING = 106,
    CLEARING_FS_DATA = 108,
    SYNCHRONIZING_DATA = 109,
    STANDBY = 110,
    STOPPING = 111,
    ROLLBACK_ERROR = 112,
    ERASING = 114,
    VERIFYING = 115,
    REMOVING1 = 117,
    AIRGAPDISCONNECT = 118,
    CREATING = 119
}

/**
 * 运行状态枚举列表
 */
export const runningStatusE = {
    Unknown: {
        value: 0,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_UNKNOWN',
    },
    Normal: {
        value: 1,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_NORMAL',
    },
    RUNNING: {
        value: 2,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_RUNNING',
    },
    Not_Running: {
        value: 3,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_NOT_RUNNING',
    },
    Not_Exist: {
        value: 4,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_NOT_EXIST',
    },
    High_Temperature_Sleep: {
        value: 5,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_HIGH_TEMPERATURE_SLEEP',
    },
    STARTING: {
        value: 6,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_STARTING',
    },
    Power_Failure_Protecting: {
        value: 7,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_POWER_FAILURE_PROTECTING',
    },
    SLEEPING: {
        value: 8,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_SLEEPING',
    },
    SPINGUP: {
        value: 9,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_SPINGUP',
    },
    LINK_UP: {
        value: 10,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_LINK_UP',
    },
    LINK_DOWN: {
        value: 11,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_LINK_DOWN',
    },
    Powering_On: {
        value: 12,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_POWER_ON',
    },
    Power_Off: {
        value: 13,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_POWER_OFF',
    },
    Precopy: {
        value: 14,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_PRE_COPY',
    },
    COPYBACK: {
        value: 15,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_COPYBACK',
    },
    Reconstruction: {
        value: 16,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_RECONSTRUCTION',
    },
    EXPANSION: {
        value: 17,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_EXPANSION',
    },
    NOT_FORMAT: {
        value: 18,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_NOT_FORMAT',
    },
    FORMATTING: {
        value: 19,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_FORMATTING',
    },
    UNMAPPING: {
        value: 20,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_UNMAPPING',
    },
    INITIAL_SYNCHRONIZING: {
        value: 21,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_INITIAL_SYNCHRONIZING',
    },
    CONSISTENT: {
        value: 22,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_CONSISTENT',
    },
    SYNCHRONIZING: {
        value: 23,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_SYNCHRONIZING',
    },
    SYNCHRONIZED: {
        value: 24,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_SYNCHRONIZED',
    },
    Not_Synchronized: {
        value: 25,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_NOT_SYNCHRONIZED',
    },
    SPLIT: {
        value: 26,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_SPLIT',
    },
    Online: {
        value: 27,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_ONLINE',
    },
    Offline: {
        value: 28,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_OFFLINE',
    },
    LOCKED: {
        value: 29,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_LOCKED',
    },
    ENABLE: {
        value: 30,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_ENABLE',
    },
    Disabled: {
        value: 31,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_DISABLED',
    },
    LEVELING: {
        value: 32,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_LEVELING',
    },
    To_be_Recovered: {
        value: 33,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_TO_BE_RECOVERD',
    },
    Interrupted: {
        value: 34,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_INTERRUPTED',
    },
    Invalid: {
        value: 35,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_INVALID',
    },
    NOSTART: {
        value: 36,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_NOSTART',
    },
    Queuing: {
        value: 37,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_QUEUING',
    },
    STOP: {
        value: 38,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_STOP',
    },
    COPYING: {
        value: 39,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_COPYING',
    },
    COMPLETED: {
        value: 40,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_COMPLETED',
    },
    Paused: {
        value: 41,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_PAUSE',
    },
    REVSYNCHRONIZING: {
        value: 42,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_REVSYNCHRONIZING',
    },
    Activated: {
        value: 43,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_ACTIVATED',
    },
    Restore: {
        value: 44,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_ROLLBACK',
    },
    Inactive: {
        value: 45,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_INACTIVATED',
    },
    IDLE: {
        value: 46,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_IDLE',
    },
    Power_off: {
        value: 47,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_POWERING_OFF',
    },
    CHARGING: {
        value: 48,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_CHARGING',
    },
    CHARGED: {
        value: 49,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_CHARGED',
    },
    DISCHARGING: {
        value: 50,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_DISCHARGING',
    },
    Upgrading: {
        value: 51,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_UPGRADING',
    },
    Power_Lost: {
        value: 52,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_POWER_LOST',
    },
    Initializing: {
        value: 53,
        i18n: 'common.EnumDefine_RUNNING_STATUS_INITIALIZING',
    },
    Apply_Config_Change: {
        value: 54,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_APPLY_CONFIG_CHANGE',
    },
    Online_Disable: {
        value: 55,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_ONLINE_DISABLE',
    },
    Offline_Disable: {
        value: 56,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_OFFLINE_DISABLE',
    },
    ONLINE_FROZEN: {
        value: 57,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_ONLINE_FROZEN',
    },
    Offline_Frozen: {
        value: 58,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_OFFLINE_FROZEN',
    },
    CLOSED: {
        value: 59,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_CLOSED',
    },
    REMOVING: {
        value: 60,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_REMOVING',
    },
    INSERVICE: {
        value: 61,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_INSERVICE',
    },
    OUTOFSERVICE: {
        value: 62,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_OUTOFSERVICE',
    },
    Erasement_Running_Normal: {
        value: 63,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_ERASEMENT_RUNNING_NORMAL',
    },
    Erasement_Running_Fail: {
        value: 64,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_ERASEMENT_RUNNING_FAIL',
    },
    Erasement_Running_Success: {
        value: 65,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_ERASEMENT_RUNNING_SUCCESS',
    },
    CANCELING: {
        value: 69,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_CANCELING',
    },
    CANCELED: {
        value: 70,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_CANCELED',
    },
    Fault: {
        value: 74,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_MIGRATION_FAULT',
    },
    Migrating: {
        value: 75,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_MiGRATING',
    },
    Migrated: {
        value: 76,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_MIGRATION_COMPLETED',
    },
    ACTIVATING: {
        value: 77,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_ACTIVATING',
    },
    DEACTIVATING: {
        value: 78,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_DEACTIVATING',
    },
    SHEDULING: {
        value: 85,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_SHEDULING',
    },
    PAUSING: {
        value: 86,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_PAUSING',
    },
    SUSPENDING: {
        value: 87,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_SUSPENDING',
    },
    SUSPENDED: {
        value: 88,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_SUSPENDED',
    },
    OVERLOAD: {
        value: 89,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_OVERLOAD',
    },
    To_Be_Switch: {
        value: 90,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_TO_BE_SWITCH',
    },
    SWITCHING: {
        value: 91,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_SWITCHING',
    },
    To_Be_Cleanup: {
        value: 92,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_TO_BE_CLEANUP',
    },
    Forced_Start: {
        value: 93,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_FORCED_START',
    },
    ERROR: {
        value: 94,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_ERROR',
    },
    Job_Completed: {
        value: 95,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_JOB_COMPLETED',
    },
    Partition_Migrating: {
        value: 96,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_PARTITION_MIGRATING',
    },
    MOUNT: {
        value: 97,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_MOUNT',
    },
    UNMOUNT: {
        value: 98,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_UNMOUNT',
    },
    INSTALLING: {
        value: 99,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_INSTALLING',
    },
    To_be_Synchronized: {
        value: 100,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_TO_BE_SYNCHRONIZED',
    },
    Connecting: {
        value: 101,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_CONNECTING',
    },
    Power_On_Error: {
        value: 103,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_POWER_ON_ERROR',
    },
    REPAIRING: {
        value: 104,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_REPAIRING',
    },
    ABNORMAL: {
        value: 105,
        i18n: 'common.EnumDefine_STATUS_E_ABNORMAL',
    },
    Deleting: {
        value: 106,
        i18n: 'common.EnumDefine_RUNNING_STATUS_REMOVING',
    },
    Clearing_Fs_Data: {
        value: 108,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_CLEARING_FS_DATA',
    },
    Synchronizing_Data: {
        value: 109,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_SYNCHRONIZING_DATA',
    },
    Stand_By: {
        value: 110,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_STANDBY',
    },
    Stopping: {
        value: 111,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_STOPPING',
    },
    ROLLBACK_ERROR: {
        value: 112,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_ROLLBACK_ERROR',
    },
    Erasing: {
        value: 114,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_ERASING',
    },
    Verifying: {
        value: 115,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_VERIFYING',
    },
    Removing: {
        value: 117,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_REMOVING1',
    },
    Air_Gap_Down: {
        value: 118,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_AIRGAPDISCONNECT',
    },
    Creating: {
        value: 119,
        i18n: 'common.EnumDefine_RUNNING_STATUS_E_CREATING',
    },
};
